
export default {
  title: "Terms of Service",
  subtitle: "Please read the following terms carefully. Using our services indicates your agreement to these terms",
  lastUpdated: "Last updated: January 15, 2024",
  intro: "Welcome to Deriway's payment services. These Terms of Service (\"Terms\") constitute a legally binding agreement between you and Deriway.",
  
  section1: {
    title: "1. Service Description",
    intro: "Deriway provides the following payment acquiring services:",
    item1: "• Online payment acquiring and processing services",
    item2: "• Multi-channel payment access (credit cards, debit cards, e-wallets, etc.)",
    item3: "• Cross-border payment and currency exchange services",
    item4: "• Fund clearing and settlement services",
    item5: "• Payment data analytics and risk control services"
  },
  
  section2: {
    title: "2. Merchant Eligibility",
    intro: "To use our acquiring services, you must:",
    item1: "• Be a legally registered business or individual business owner",
    item2: "• Provide true, accurate, and complete merchant information and qualification documents",
    item3: "• Engage in legal business activities",
    item4: "• Not be in industries or regions where our services are restricted",
    item5: "• Pass our merchant review and compliance check"
  },
  
  section3: {
    title: "3. Account Management",
    registration: "Account Registration: You need to complete merchant onboarding and qualification review to use acquiring services",
    security: "Account Security: You are responsible for protecting merchant account security, including API keys and payment passwords",
    responsibility: "Account Responsibility: You are responsible for all transactions and operations under your account",
    suspension: "Account Suspension: We have the right to suspend or close your merchant account when violations or risks are detected"
  },
  
  section4: {
    title: "4. Payment Processing Rules",
    intro: "When using payment services, you agree to:",
    item1: "• Follow payment industry standards and our transaction rules",
    item2: "• Ensure the authenticity and legality of transactions",
    item3: "• Cooperate in handling refunds, disputes and chargebacks",
    item4: "• Not engage in fraudulent transactions or money laundering activities",
    item5: "• Accept our risk control measures and transaction monitoring"
  },
  
  section5: {
    title: "5. Fees and Settlement",
    intro: "Our fee structure is as follows:",
    trading: "• Transaction fees: Charged as a percentage of transaction amount",
    withdrawal: "• Withdrawal fees: Charged based on withdrawal method and amount",
    management: "• Service fees: Account maintenance and technical service fees",
    other: "• Other fees: Refund processing fees, dispute handling fees, etc.",
    notice: "• Settlement cycle: T+1 or T+7, subject to contract agreement"
  },
  
  section6: {
    title: "6. Risk Disclosure",
    intro: "Payment acquiring business involves the following risks:",
    market: "• Chargeback risk: Cardholders may initiate chargeback requests",
    liquidity: "• Fund risk: May face fund freezing or withholding",
    credit: "• Credit risk: Counterparty default or fraud",
    operational: "• Technical risk: System failures may affect transaction processing",
    regulatory: "• Compliance risk: Impact of regulatory policy changes"
  },
  
  section7: {
    title: "7. Compliance Obligations",
    intro: "You must comply with the following compliance requirements:",
    kyc: "• Cooperate to complete merchant due diligence (KYB) procedures",
    aml: "• Comply with anti-money laundering and counter-terrorism financing regulations",
    reporting: "• Truthfully declare transaction information and tax materials",
    sanctions: "• Not trade with sanctioned individuals or entities",
    laws: "• Comply with payment industry regulations and regulatory requirements"
  },
  
  section8: {
    title: "8. Service Limitations",
    intro: "We reserve the following rights:",
    item1: "• Refuse to process suspicious or high-risk transactions",
    item2: "• Suspend or terminate services for violating merchants",
    item3: "• Adjust rates and service conditions",
    item4: "• Freeze funds or accounts in emergency situations",
    item5: "• Cooperate with regulatory authorities and law enforcement investigations"
  },
  
  section9: {
    title: "9. Limitation of Liability",
    intro: "To the maximum extent permitted by law:",
    item1: "• We are not liable for indirect losses or profit losses",
    item2: "• Our compensation liability does not exceed the disputed transaction amount",
    item3: "• We do not guarantee absolute stability of payment services",
    item4: "• You acknowledge that payment business involves inherent risks",
    item5: "• Force majeure events exempt us from liability"
  },
  
  section10: {
    title: "10. Dispute Resolution",
    intro: "In case of disputes:",
    negotiation: "• First resolve through customer service channels",
    arbitration: "• If negotiation fails, third-party mediation may be applied",
    costs: "• Dispute handling costs are borne according to responsibility ratio"
  },
  
  section11: {
    title: "11. Terms Modification",
    intro: "We may modify these terms:",
    item1: "• Major modifications will be notified in writing 30 days in advance",
    item2: "• Continued use of services is deemed acceptance of modifications",
    item3: "• Those who disagree with modifications may terminate the service agreement",
    item4: "• Modified terms are effective for all merchants"
  },
  
  section12: {
    title: "12. Contact Information",
    intro: "If you have questions or need support, please contact us:",
    email: "• Customer service email: support@deriway.com",
    telegram: "• Business cooperation: @deriway_business",
    hours: "• Service hours: Weekdays 9:00-18:00",
    response: "• We will respond to your inquiries within 24 hours"
  }
};